// frontend/src/pages/Login.js
import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function Login({ setUser }) {
  const [phone, setPhone] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('login'); // login | profile
  const [tempUser, setTempUser] = useState(null);

  const formatPhone = (value) => {
    let cleaned = value.replace(/[^\d+]/g, '');
    if (cleaned.startsWith('8')) cleaned = '+7' + cleaned.slice(1);
    if (cleaned.startsWith('7') && !cleaned.startsWith('+')) cleaned = '+' + cleaned;
    return cleaned;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);

    if (!phone || phone.length < 10) {
      setError('Введите номер телефона');
      setLoading(false); return;
    }
    if (!pin || pin.length !== 4) {
      setError('Введите пин-код (4 цифры)');
      setLoading(false); return;
    }

    try {
      // Шаг 1: проверяем телефон
      const formData1 = new FormData();
      formData1.append('phone', phone);
      const resp1 = await axios.post(`${API_URL}/api/auth/login`, formData1);
      
      // Шаг 2: проверяем пин
      const formData2 = new FormData();
      formData2.append('employee_id', resp1.data.employee_id);
      formData2.append('pin', pin);
      const resp2 = await axios.post(`${API_URL}/api/auth/verify`, formData2);
      
      const userData = resp2.data;
      
      // Сохраняем информацию о филиале
      if (userData.branch_name) {
        userData.branch_display = `🏢 ${userData.branch_name}`;
      }
      
      if (userData.need_profile) {
        setTempUser(userData);
        setStep('profile');
      } else {
        setUser(userData);
        sessionStorage.setItem('moyobed_user', JSON.stringify(userData));
      }
    } catch (err) {
      if (err.response?.status === 404) setError('Сотрудник не найден');
      else if (err.response?.status === 403) setError('Неверный пин-код');
      else setError('Ошибка сервера');
    } finally {
      setLoading(false);
    }
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    const lastName = e.target.lastName.value.trim();
    const initials = e.target.initials.value.trim().toUpperCase().replace(/[^А-Я]/g, '');
    
    if (!lastName) { setError('Введите фамилию'); setLoading(false); return; }
    
    try {
      const formData = new FormData();
      formData.append('employee_id', tempUser.id);
      formData.append('last_name', lastName);
      formData.append('initials', initials);
      await axios.post(`${API_URL}/api/auth/profile`, formData);
      
      const updated = { 
        ...tempUser, 
        last_name: lastName, 
        initials, 
        full_name: `${lastName} ${initials}`.trim(), 
        need_profile: false 
      };
      
      // Сохраняем информацию о филиале
      if (updated.branch_name) {
        updated.branch_display = `🏢 ${updated.branch_name}`;
      }
      
      setUser(updated);
      sessionStorage.setItem('moyobed_user', JSON.stringify(updated));
    } catch (err) {
      setError('Ошибка сохранения');
    } finally { setLoading(false); }
  };

  // Шаг: профиль (для новых)
  if (step === 'profile') {
    return (
      <div className="page login-page">
        <div className="login-container">
          <div className="decor-circle decor-1"></div>
          <div className="decor-circle decor-2"></div>
          <div className="login-card card">
            <div className="login-logo">
              <div className="logo-icon">👤</div>
              <h1 className="login-brand">Edato</h1>
              <p className="login-subtitle">Представьтесь, пожалуйста</p>
              {tempUser?.branch_name && (
                <div className="branch-info-login" style={{ marginTop: 8, fontSize: 14, color: 'var(--text-light)' }}>
                  🏢 {tempUser.branch_name}
                </div>
              )}
            </div>
            <form onSubmit={handleProfileSubmit} className="login-form">
              <label className="input-label">Фамилия</label>
              <input type="text" className="input" name="lastName" placeholder="Иванов" autoFocus />
              <label className="input-label" style={{ marginTop: 12 }}>Инициалы</label>
              <input type="text" className="input" name="initials" placeholder="АА" maxLength={4} />
              {error && <div className="error-message">{error}</div>}
              <button type="submit" className="btn login-btn" disabled={loading} style={{ marginTop: 16, width: '100%' }}>
                {loading ? <span className="spinner"></span> : 'Продолжить'}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  // Основной экран входа
  return (
    <div className="page login-page">
      <div className="login-container">
        <div className="decor-circle decor-1"></div>
        <div className="decor-circle decor-2"></div>
        <div className="login-card card">
          <div className="login-logo">
            <div className="logo-icon">🍽️</div>
            <h1 className="login-brand">Мой обед</h1>
            <p className="login-subtitle">Заказ питания</p>
          </div>
          <form onSubmit={handleLogin} className="login-form">
            <label className="input-label">Телефон</label>
            <input
              type="tel" className="input phone-input"
              placeholder="+7 (___) ___-__-__"
              value={phone} onChange={(e) => setPhone(formatPhone(e.target.value))}
              autoFocus
            />
            <label className="input-label" style={{ marginTop: 12 }}>Пин-код</label>
            <input
              type="password" className="input"
              placeholder="4 цифры" maxLength={4}
              value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
            />
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className={`btn login-btn ${loading ? 'loading' : ''}`} disabled={loading} style={{ marginTop: 16, width: '100%' }}>
              {loading ? <span className="spinner"></span> : 'Войти'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
